import { Pipe, PipeTransform } from '@angular/core';
import { safeJsonParse } from '@frontend/unhideschool/app/helpers/utility-functions';

@Pipe({
    name: 'parseJson'
})

export class ParseJsonPipe implements PipeTransform {
    transform(jsonstr: string): any {
        return safeJsonParse(jsonstr);
    }
}